export default __webpack_public_path__ + "static/media/status-update.9d2e6a5e.svg";